import { useEffect, useState } from "react";
import fetchWithTimeout from "../utils/fetchWithTimeout.js";
import analytics from "../analytics/analytics.js";
const usePostSurveyContent = (variables)=>{
    const [isAnswersSent, setIsAnswersSent] = useState(false);
    useEffect(()=>{
        const postIt = async ()=>{
            const url = "/genai-svc/genai/survey/send-answers";
            const response = await fetchWithTimeout(url, {
                method: 'POST',
                body: JSON.stringify({
                    encodedId: variables?.encodedId,
                    answers: variables?.answers
                })
            });
            if (response.ok) {
                const result = await response.json();
                setIsAnswersSent(result.isAnswersSent);
            }
        };
        if (variables?.answers?.length && variables?.encodedId) postIt().catch((e)=>{
            analytics.log({
                message: e.message,
                source: 'usePostSurveryContent'
            });
        });
    }, [
        variables
    ]);
    return {
        isAnswersSent
    };
};
const hooks_usePostSurveyContent = usePostSurveyContent;
export { hooks_usePostSurveyContent as default };
